module.exports = __webpack_public_path__ + "static/media/KohinoorBangla-Medium.39078549.svg";